import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import QuestionAnswer from "../../../V2/Sections/QuestionAnswer"

const QuestionAnswerBlock = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.QuestionAnswerBlock>) => {
  return (
    <QuestionAnswer
      answers={blok.answers}
      question={blok.question}
      iconColor={blok.quoteColor}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default QuestionAnswerBlock
